import DesignService from "@/services/DesignService.js";
import _ from "lodash";

export default {
  namespaced: true,
  state: {
    popups: [],
    errors: null,
    loading: false,
    homeWebLayout: {},
    iconsAndLogos: null,
    orderStatusDesign: null
  },
  getters: {
    loading: state => state.loading,
    homeWebLayout: state => state.homeWebLayout,
    aboutUs: state => Object.keys(state.homeWebLayout).length ?
      JSON.parse(state.homeWebLayout.about_us) :
      null,
    pendingDesign: state =>
      state.orderStatusDesign &&
        state.orderStatusDesign.constructor.name === "Object" &&
        state.orderStatusDesign.enable &&
        state.orderStatusDesign.pending &&
        state.orderStatusDesign.pending.constructor.name === "Object"
        ? state.orderStatusDesign.pending
        : null,
    processingDesign: state =>
      state.orderStatusDesign &&
        state.orderStatusDesign.constructor.name === "Object" &&
        state.orderStatusDesign.enable &&
        state.orderStatusDesign.processing &&
        state.orderStatusDesign.processing.constructor.name === "Object"
        ? state.orderStatusDesign.processing
        : null,
    dispatchedDesign: state =>
      state.orderStatusDesign &&
        state.orderStatusDesign.constructor.name === "Object" &&
        state.orderStatusDesign.enable &&
        state.orderStatusDesign.dispatched &&
        state.orderStatusDesign.dispatched.constructor.name === "Object"
        ? state.orderStatusDesign.dispatched
        : null,
    pickupDesign: state =>
      state.orderStatusDesign &&
        state.orderStatusDesign.constructor.name === "Object" &&
        state.orderStatusDesign.enable &&
        state.orderStatusDesign.pick_up &&
        state.orderStatusDesign.pick_up.constructor.name === "Object"
        ? state.orderStatusDesign.pick_up
        : null,
    deliveredDesign: state =>
      state.orderStatusDesign &&
        state.orderStatusDesign.constructor.name === "Object" &&
        state.orderStatusDesign.enable &&
        state.orderStatusDesign.delivered &&
        state.orderStatusDesign.delivered.constructor.name === "Object"
        ? state.orderStatusDesign.delivered
        : null,
    claimedDesign: state =>
      state.orderStatusDesign &&
        state.orderStatusDesign.constructor.name === "Object" &&
        state.orderStatusDesign.enable &&
        state.orderStatusDesign.claimed &&
        state.orderStatusDesign.claimed.constructor.name === "Object"
        ? state.orderStatusDesign.claimed
        : null,
  },
  mutations: {
    setPopups(state, value) {
      state.popups = value;
    },
    setErrors(state, value) {
      state.errors = value;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setHomeWebLayout(state, layout) {
      const availableSections = layout ? _.uniq(Object.keys(layout).map(section => section.split('.')[0])) : [];
      const minimumSections = ['categories', 'our_brands', 'about_us', 'whats_nearby'];
      const isMinimumSectionsVisible = _.uniqBy(availableSections.map(section => {
        return minimumSections.includes(section)
          ? layout[`${section}.enable`]
          : false
      }), true);

      if (availableSections.length == 0 || !isMinimumSectionsVisible) {
        layout['whats_nearby.enable'] = true;
        layout['whats_nearby.weight'] = 1;
      }
      state.homeWebLayout = layout ? layout : {};
    },
    setIconsAndLogos(state, payload) {
      state.iconsAndLogos = payload
    },
    setOrderStatusDesign(state, payload) {
      state.orderStatusDesign = payload
    }
  },
  actions: {
    async getPopups({ commit }, request) {
      try {
        const response = await DesignService.getPopups(request);

        if (response.pop_ups && response.pop_ups.length)
          commit("setPopups", response.pop_ups);
      } catch (errors) {
        commit("setErrors", errors);
      }
    },
    async getHomeWebLayout({ commit }, request) {
      commit("setLoading", true);
      try {
        const { data } = await DesignService.getHomeWebLayout(request);
        commit("setHomeWebLayout", data);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", false);
      }
    },
    async getIconsAndLogos({ commit }, request) {
      commit("setLoading", true);
      try {
        const { data } = await DesignService.getIconsAndLogos(request);
        commit("setIconsAndLogos", data);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", false);
      }
    },
    async getOrderStatusDesign({ commit }, request) {
      commit("setLoading", true);

      try {
        const { data } = await DesignService.getOrderStatusDesign(request);
        commit("setOrderStatusDesign", data);
      } catch (errors) {
        commit("setErrors", errors);
      } finally {
        commit("setLoading", false);
      }
    }
  }
};
